(function () {
    'use strict';

    const config = window.MeilisearchCollectionConfig;
    if (!config) {
        console.error('MeilisearchCollectionConfig not found.');
        return;
    }

    // The grid is JS-rendered and windowed, so native scroll restoration would
    // re-apply a stale absolute position; disable it and position ourselves
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

    const MEILISEARCH_HOST = config.meilisearchHost;
    const MEILISEARCH_API_KEY = config.meilisearchApiKey;
    const MEILISEARCH_INDEX = config.meilisearchIndex;
    const collectionId = config.collectionId || null;
    const collectionHandle = config.collectionHandle || null;
    const currentLocale = config.currentLocale;
    const showOutOfStock = config.showOutOfStock;
    const searchMode = config.searchMode === true;
    const initialQuery = config.initialQuery || '';

    // When filter_settings.showOutOfStockOptions is off, product-option facets use
    // the `_available` field so values whose matching variant is out of stock hide
    function effectiveFilterField(f) {
        return (filterSettings.showOutOfStockOptions === false && f.type === 'product_option')
            ? f.meilisearchField + '_available'
            : f.meilisearchField;
    }

    // Batch size per fetch, multiples of the column count (2 mobile / 3 desktop)
    var hitsPerPage = window.matchMedia('(max-width: 767px)').matches ? 30 : 36;
    var _shouldScrollTop = false;

    var searchInitialized = false;
    var _search = null;
    var _bfcacheRestored = false;
    var _pageRefine = null;
    var _pageNbPages = 0;
    var _pageListenerAdded = false;

    // Infinite scroll / position-restore state
    var _currentLoadedCount = 0;   // product cards currently in the grid
    var _gridMinPage = 0;          // lowest page index currently in the grid window
    var RESTORE_KEY = 'hoj_ms_restore_v1';
    // Keep in sync with the Meilisearch index `maxTotalHits` pagination setting
    var MAX_TOTAL_HITS = 5000;

    function _stateKey() {
        return window.location.pathname + window.location.search;
    }

    function readRestoreSnapshot() {
        try { return JSON.parse(sessionStorage.getItem(RESTORE_KEY) || 'null'); }
        catch (e) { return null; }
    }

    function clearRestoreSnapshot() {
        try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
    }

    // True only when the page was reached via the browser back/forward button
    function isBackForwardNav() {
        try {
            var nav = performance.getEntriesByType('navigation')[0];
            if (nav && nav.type) return nav.type === 'back_forward';
        } catch (e) {}
        try { return !!(performance.navigation && performance.navigation.type === 2); } catch (e) {}
        return false;
    }

    // Save scroll depth + paging when a product is opened, to restore on back-nav
    document.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('a[href*="/products/"]');
        if (!link) return;
        if (!document.getElementById('meilisearch-collection-grid')) return;
        var productPath = '';
        try { productPath = new URL(link.href, window.location.origin).pathname; }
        catch (_) { productPath = link.getAttribute('href') || ''; }
        try {
            var card = link.closest('.af-productGrid_item');
            var items = document.querySelectorAll('#ms-hits-list .af-productGrid_item');
            var domIndex = card ? Array.prototype.indexOf.call(items, card) : 0;
            if (domIndex < 0) domIndex = 0;
            var snapshot = {
                key: _stateKey(),
                index: _gridMinPage * hitsPerPage + domIndex,   // absolute position in results
                anchorOffset: card ? Math.round(card.getBoundingClientRect().top) : 0,
                scrollY: Math.round(window.scrollY || window.pageYOffset || 0),
                productPath: productPath,
                ts: Date.now()
            };
            sessionStorage.setItem(RESTORE_KEY, JSON.stringify(snapshot));
        } catch (_) {}
    }, true);

    window.addEventListener('pagehide', function () {
        if (_search) {
            _search.dispose();
            _search = null;
        }
    });

    window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        
        var snap = readRestoreSnapshot();
        if (snap && snap.key === _stateKey()) {
            try { sessionStorage.setItem('hoj_ms_bfreload', '1'); } catch (_) {}
            window.location.reload();
            return;
        }
        _bfcacheRestored = true;
        searchInitialized = false;
        initInstantSearch();
    });

    let filterSettings = { filters: [], showOutOfStock: true };
    try {
        if (typeof config.filterSettings === 'string') {
            filterSettings = JSON.parse(config.filterSettings);
        } else if (typeof config.filterSettings === 'object' && config.filterSettings !== null) {
            filterSettings = config.filterSettings;
        }
    } catch (e) {
        console.error('Error parsing filterSettings:', e);
    }


    function checkAndInitSearch() {
        if (searchInitialized) return true;
        if (typeof window.instantsearch !== 'undefined' && typeof instantMeiliSearch !== 'undefined') {
            searchInitialized = true;
            startSearch();
            return true;
        }
        return false;
    }

    function initInstantSearch() {
        if (checkAndInitSearch()) return;
        var checkCount = 0;
        var safetyCheck = setInterval(function () {
            checkCount++;
            if (checkAndInitSearch() || checkCount > 50) {
                clearInterval(safetyCheck);
                if (checkCount > 50) console.error('InstantSearch libraries failed to load');
            }
        }, 100);
    }

    function escapeHtml(text) {
        if (text === null || text === undefined) return '';
        const div = document.createElement('div');
        div.textContent = String(text);
        return div.innerHTML;
    }

    function getFilterLabel(filter) {
        if (filter.translations && filter.translations[currentLocale]) {
            return filter.translations[currentLocale];
        }
        return filter.label || filter.meilisearchField;
    }

    function formatPrice(price, currency) {
        currency = currency || 'CHF';
        if (!price && price !== 0) return '';
        const num = typeof price === 'string' ? parseFloat(price) : price;
        return currency + ' ' + num.toFixed(2);
    }

    function getLocalizedTitle(hit) {
        return hit['title_' + currentLocale] || hit.title || 'Product';
    }

    function sanitizeId(value) {
        return String(value).replace(/[^a-zA-Z0-9]/g, '_');
    }

    function extractImageUrl(val) {
        if (!val) return '';
        if (typeof val === 'string') return val;
        if (typeof val === 'object') {
            return val.src || val.url || val.originalSrc || val.transformedSrc || '';
        }
        return '';
    }

    function getHitImageUrl(hit) {
        var url = '';
        var candidates = ['featured_image', 'featuredImage', 'image'];
        for (var i = 0; i < candidates.length; i++) {
            url = extractImageUrl(hit[candidates[i]]);
            if (url) return url;
        }
        if (hit.images && hit.images.length > 0) {
            url = extractImageUrl(hit.images[0]);
            if (url) return url;
        }
        return '';
    }

    function buildProductImg(url, alt) {
        var fallback = 'https://aico.apps.aico.swiss/images/no-images.png';
        var src = url || fallback;
        var common = ' class="product-img" alt="' + escapeHtml(alt || 'Product') + '"' +
            ' onerror="this.onerror=null;this.removeAttribute(\'srcset\');this.src=\'' + fallback + '\'"' +
            ' loading="lazy"';
        if (/cdn\.shopify|\/cdn\/shop|shopifycdn/i.test(src)) {
            var base = src.replace(/_(\d+)x(\d+)?(\.(?:jpg|jpeg|png|webp|gif))/i, '$3');
            var sep = base.indexOf('?') === -1 ? '?' : '&';
            var widths = [200, 300, 400, 540, 720];
            var srcset = widths.map(function (w) {
                return escapeHtml(base + sep + 'width=' + w) + ' ' + w + 'w';
            }).join(', ');
            return '<img' + common +
                ' src="' + escapeHtml(base + sep + 'width=400') + '"' +
                ' srcset="' + srcset + '"' +
                ' sizes="(max-width: 640px) 50vw, 30vw">';
        }
        return '<img' + common + ' src="' + escapeHtml(src) + '">';
    }

    function renderSkeletonHtml(count) {
        var card =
            '<li class="af-productGrid_item">' +
            '<div class="af-productCard ms-skeleton-card">' +
            '<div class="af-productCard-image">' +
            '<a class="ms-skeleton ms-skeleton-image" aria-hidden="true" tabindex="-1"></a>' +
            '</div>' +
            '<div class="af-productCard-content">' +
            '<div class="ms-skeleton ms-skeleton-title"></div>' +
            '<div class="ms-skeleton ms-skeleton-price"></div>' +
            '</div>' +
            '</div>' +
            '</li>';
        var html = '';
        for (var i = 0; i < count; i++) html += card;
        return html;
    }

    function renderHitHtml(hit) {
        const title = getLocalizedTitle(hit);
        const currency = hit.currency || 'CHF';
        const price = hit.min_price != null ? hit.min_price
            : (hit.minPrice || hit.price || (hit.variants && hit.variants[0] && parseFloat(hit.variants[0].price)) || 0);
        const compareAtPrice = hit.min_compare_at_price || hit.max_compare_at_price ||
            hit.compareAtPrice || hit.compare_at_price || 0;

        const image = getHitImageUrl(hit);
        const handle = hit.handle || hit.product_handle || '';
        const url = '/products/' + handle;

        const isNew = hit.isNew === true;
        const isSale = hit.isSale === true || (compareAtPrice > 0 && compareAtPrice > price);

        let badge = '';
        if (isSale) {
            badge = '<div class="card__badge aico-sale-button"><span class="badge badge--bottom-left badge--sale">Sale</span></div>';
        } else if (isNew) {
            badge = '<div class="card__badge aico-sale-button"><span class="badge badge--bottom-left badge--new-in">NEU</span></div>';
        }

        let priceHtml = '';
        if (isSale && compareAtPrice > 0) {
            priceHtml =
                '<span class="aico-sale-price">' + formatPrice(price, currency) + '</span>' +
                '<span class="aico-regular-price">' + formatPrice(compareAtPrice, currency) + '</span>';
        } else {
            priceHtml = formatPrice(price, currency);
        }

        const imgTag = buildProductImg(image, title);

        return (
            '<li class="af-productGrid_item">' +
            '<div class="af-productCard ms-card">' +
            '<div class="af-productCard-image">' +
            '<a href="' + escapeHtml(url) + '" aria-label="View ' + escapeHtml(title) + '">' +
            imgTag +
            '</a>' +
            badge +
            '</div>' +
            '<div class="af-productCard-content">' +
            '<div class="af-productCard-title">' +
            '<h3><a href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a></h3>' +
            '</div>' +
            '<div class="af-productCard-price">' + priceHtml + '</div>' +
            '</div>' +
            '</div>' +
            '</li>'
        );
    }

    function startSearch() {
        // Default to infinite scroll unless a template explicitly opts into numbers
        const useInfinite = config.infiniteScroll !== false;

        // On back-nav, restore by windowing to the saved page (decided here, applied
        // in setupInfiniteScroll)
        var _restoreSnap = null;
        if (useInfinite) {
            var _snap0 = readRestoreSnapshot();
            var _bf = isBackForwardNav();
            var _bfReload = false;
            try { _bfReload = sessionStorage.getItem('hoj_ms_bfreload') === '1'; if (_bfReload) sessionStorage.removeItem('hoj_ms_bfreload'); } catch (e) {}
            if (_snap0 && _snap0.key === _stateKey() && (Date.now() - (_snap0.ts || 0)) < 1800000 &&
                (_bf || _bfcacheRestored || _bfReload)) {
                _restoreSnap = _snap0;
            } else if (_snap0 && (Date.now() - (_snap0.ts || 0)) >= 1800000) {
                clearRestoreSnapshot();
            }
        }
        const searchClient = instantMeiliSearch(MEILISEARCH_HOST, MEILISEARCH_API_KEY, {
            primaryKey: 'id',
            finitePagination: true,
            keepZeroFacets: false
        });

        const baseFilters = [];
        if (collectionId) baseFilters.push('collections.id = ' + collectionId);
        if (!showOutOfStock) baseFilters.push('totalInventory > 0');
        const baseFilterString = baseFilters.join(' AND ');

        // The indexer mirrors every product's rank inside each collection as
        // `position_in_collection_<handle>`, hyphens replaced by underscores.
        // Sorting on it reproduces the order the merchant set in the admin,
        // which is what a collection page must show by default.
        const COLLECTION_SORT = collectionHandle
            ? MEILISEARCH_INDEX + ':position_in_collection_' + collectionHandle.replace(/-/g, '_') + ':asc'
            : null;
        // `isNew` is a boolean: sorting on it only splits new from not-new and
        // leaves the order within each group arbitrary. createdAt is the real one.
        const NEWEST_SORT = MEILISEARCH_INDEX + ':createdAt:desc';
        const PRICE_ASC_SORT = MEILISEARCH_INDEX + ':min_price:asc';
        const PRICE_DESC_SORT = MEILISEARCH_INDEX + ':min_price:desc';
        const DEFAULT_SORT = COLLECTION_SORT || NEWEST_SORT;
        // Links shared or bookmarked before this change carry ?sortBy=<index>:isNew:desc.
        // That index is still sortable, so it answers 200 and would silently re-apply the
        // old arbitrary order while the select shows the default — drop unknown values.
        const ALLOWED_SORTS = [COLLECTION_SORT, NEWEST_SORT, PRICE_ASC_SORT, PRICE_DESC_SORT]
            .filter(function (v) { return v; });

        // Sortable attributes are only refreshed by a full reindex, so a collection
        // created since the last one has no position field yet and Meilisearch
        // answers 400. Degrade to newest-first instead of rendering an empty grid.
        const rawSearchClient = searchClient.searchClient;
        var _brokenSortIndexes = {};
        const safeSearchClient = Object.assign({}, rawSearchClient, {
            search: function (requests) {
                var patched = requests.map(function (r) {
                    return _brokenSortIndexes[r.indexName]
                        ? Object.assign({}, r, { indexName: NEWEST_SORT })
                        : r;
                });
                return rawSearchClient.search(patched).catch(function (err) {
                    var failed = patched[0] && patched[0].indexName;
                    var reason = String((err && (err.message || err.code)) || '');
                    if (failed && failed !== NEWEST_SORT && /not sortable|invalid_search_sort/i.test(reason)) {
                        console.warn('[ms-grid] ' + failed + ' is not sortable, falling back to ' + NEWEST_SORT);
                        _brokenSortIndexes[failed] = true;
                        return rawSearchClient.search(patched.map(function (r) {
                            return Object.assign({}, r, { indexName: NEWEST_SORT });
                        }));
                    }
                    throw err;
                });
            }
        });

        var validFilterAttrs = {};
        (filterSettings.filters || []).forEach(function (f) {
            validFilterAttrs[f.meilisearchField] = true;
        });

        _search = window.instantsearch({
            indexName: DEFAULT_SORT,
            searchClient: safeSearchClient,
            insights: false,
            routing: {
                stateMapping: {
                    stateToRoute: function (uiState) {
                        var firstKey = Object.keys(uiState)[0];
                        var idx = (firstKey && uiState[firstKey]) || {};
                        var route = {
                            refinementList: idx.refinementList,
                            sortBy: idx.sortBy
                        };
                        if (searchMode) route.q = idx.query || undefined;
                        if (!useInfinite && idx.page && idx.page > 1) route.page = String(idx.page);
                        return route;
                    },
                    routeToState: function (route) {
                        var state = {};
                        var idxState = {
                            refinementList: route.refinementList,
                            sortBy: ALLOWED_SORTS.indexOf(route.sortBy) === -1 ? undefined : route.sortBy
                        };
                        if (searchMode) idxState.query = route.q || initialQuery;
                        if (!useInfinite && route.page) idxState.page = parseInt(route.page, 10);
                        state[DEFAULT_SORT] = idxState;
                        return state;
                    }
                }
            }
        });

        const sortedFilters = (filterSettings.filters || [])
            .filter(function (f) {
                if (!f.excludedOnCollections || !f.excludedOnCollections.length) return true;
                return f.excludedOnCollections.indexOf(collectionHandle) === -1;
            })
            .sort(function (a, b) { return a.position - b.position; });

        const fieldLabelMap = {};
        const fieldTypeMap = {};
        sortedFilters.forEach(function (f) {
            fieldLabelMap[effectiveFilterField(f)] = getFilterLabel(f);
            fieldTypeMap[effectiveFilterField(f)] = f.type;
        });

        const configureOptions = { hitsPerPage: hitsPerPage };
        if (baseFilterString) configureOptions.filters = baseFilterString;
        _search.addWidgets([window.instantsearch.widgets.configure(configureOptions)]);

        var BASE_SIZES = { 'S': 10, 'M': 20, 'L': 30 };

        function parseSizeValue(s) {
            s = s.toUpperCase().trim();
            // Range like "S-M" or "XS-S" - average of both parts
            if (s.indexOf('-') !== -1) {
                var parts = s.split('-');
                var a = parseSizeValue(parts[0]);
                var b = parseSizeValue(parts[1]);
                if (a != null && b != null) return (a + b) / 2;
            }
            // Numeric prefix like "2XL", "3XL"
            var numMatch = s.match(/^(\d+)XL$/);
            if (numMatch) return 30 + parseInt(numMatch[1], 10) * 5;
            // Multiple X prefix: XXS=S-5*2, XXXS=S-5*3, XXL=L+5*2, XXXL=L+5*3
            var xsMatch = s.match(/^(X+)S$/);
            if (xsMatch) return 10 - xsMatch[1].length * 5;
            var xlMatch = s.match(/^(X+)L$/);
            if (xlMatch) return 30 + xlMatch[1].length * 5;
            // Base sizes
            if (BASE_SIZES[s] != null) return BASE_SIZES[s];
            return null;
        }

        function sizeSort(a, b) {
            var orderA = parseSizeValue(a.name);
            var orderB = parseSizeValue(b.name);
            if (orderA != null && orderB != null) return orderA - orderB;
            if (orderA != null) return -1;
            if (orderB != null) return 1;
            return a.name.localeCompare(b.name);
        }

        sortedFilters.forEach(function (filter) {
            const meilisearchField = filter.meilisearchField;
            const filterType = filter.type;
            const filterId = 'ms-filter-' + filter.id;

            const widgetEl = document.getElementById(filterId);
            if (!widgetEl) return;

            var inputClass, inputName;
            if (filterType === 'tag') {
                inputClass = 'aico-tags-input';
                inputName = meilisearchField;
            } else if (filterType === 'metafield') {
                inputClass = 'aico-metafield-value-filter-input';
                inputName = 'aico_nmv_' + (filter.key || '');
            } else if (filterType === 'product_option') {
                inputClass = 'aico-product-option-input';
                inputName = 'aico_option';
            } else {
                inputClass = 'aico-tags-input';
                inputName = meilisearchField;
            }

            var currentRefine = null;
            var currentRefinementItems = [];

            function attachListeners() {
                var ul = document.getElementById(filterId + '-list');
                var specificClearEl = widgetEl.querySelector('.aico-specific-clear');
                var titleEl = widgetEl.querySelector('.af-widgetTitle');

                if (ul) {
                    ul.addEventListener('change', function (e) {
                        var input = e.target;
                        if (input.type === 'checkbox' && currentRefine) {
                            _shouldScrollTop = true;
                            currentRefine(input.dataset.refineValue);
                        }
                    });
                }

                if (specificClearEl) {
                    specificClearEl.addEventListener('click', function () {
                        if (currentRefine) {
                            _shouldScrollTop = true;
                            currentRefinementItems
                                .filter(function (item) { return item.isRefined; })
                                .forEach(function (item) { currentRefine(item.value); });
                        }
                    });
                }

                if (titleEl) {
                    titleEl.addEventListener('click', function () {
                        widgetEl.classList.toggle('af-collapsed');
                        titleEl.classList.toggle('aico-rotated');
                    });
                }
            }

            const renderFn = function (renderState, isFirstRender) {
                var items = renderState.items;
                var refine = renderState.refine;

                currentRefine = refine;
                currentRefinementItems = items;

                if (isFirstRender) {
                    attachListeners();
                    var listEl = document.getElementById(filterId + '-list');
                    if (listEl && !listEl.querySelector('.ms-filter-skeleton-item')) {
                        var skeletonItems = '';
                        for (var s = 0; s < 5; s++) {
                            skeletonItems += '<li class="ms-filter-skeleton-item"><span class="ms-skeleton ms-skeleton-filter-option"></span></li>';
                        }
                        listEl.innerHTML = skeletonItems;
                    }
                    return;
                }

                widgetEl.style.display = items.length === 0 ? 'none' : '';
                if (items.length === 0) return;

                var listEl = document.getElementById(filterId + '-list');
                if (!listEl) return;

                var hasRefined = items.some(function (item) { return item.isRefined; });
                var clearEl = widgetEl.querySelector('.aico-specific-clear');
                if (clearEl) clearEl.style.display = hasRefined ? '' : 'none';

                listEl.innerHTML = items.map(function (item) {
                    var inputId = filterId + '-item-' + sanitizeId(item.value);
                    var isColor = filterType === 'tag' &&
                        typeof item.value === 'string' &&
                        item.value.indexOf('color_#') === 0;

                    var labelInner = '';
                    if (isColor) {
                        var hex = item.value.replace('color_', '');
                        labelInner =
                            '<span class="color-span" style="background:' + hex +
                            ';height:18px;width:18px;border-radius:100%;border:1px solid;display:inline-block;"></span>' +
                            '<span class="af-label af-color-label" style="display:none;">' + escapeHtml(hex) + '</span>';
                    } else {
                        labelInner = '<span class="af-label">' + escapeHtml(item.label) + '</span>';
                    }

                    var countHtml = '<span class="af-tags-count">(' + item.count + ')</span>';

                    var extraInputAttrs = '';
                    if (filterType === 'product_option') {
                        extraInputAttrs = ' af-display-option="' + escapeHtml((filter.optionName || '').toLowerCase()) + '"';
                    }

                    var labelClass = item.isRefined ? 'af-radio-active' : (isColor ? 'color-label-span' : '');

                    return (
                        '<li>' +
                        '<input type="checkbox"' +
                        ' id="' + inputId + '"' +
                        ' class="' + inputClass + '"' +
                        ' select-type="multiple"' +
                        ' value="' + escapeHtml(item.value) + '"' +
                        ' data-refine-value="' + escapeHtml(item.value) + '"' +
                        ' name="' + inputName + '"' +
                        extraInputAttrs +
                        (item.isRefined ? ' checked' : '') +
                        '>' +
                        '<label for="' + inputId + '"' + (labelClass ? ' class="' + labelClass + '"' : '') + '>' +
                        labelInner +
                        countHtml +
                        '</label>' +
                        '</li>'
                    );
                }).join('');
            };

            var filterLabel = getFilterLabel(filter).toLowerCase();
            var isSizeFilter = filterLabel.indexOf('gröss') !== -1 || filterLabel.indexOf('size') !== -1;

            const customRefinementList = window.instantsearch.connectors.connectRefinementList(renderFn);
            _search.addWidgets([
                customRefinementList({
                    attribute: effectiveFilterField(filter),
                    operator: 'or',
                    limit: 500,
                    sortBy: isSizeFilter ? sizeSort : ['name:asc']
                })
            ]);
        });

        var currentRefinementsRefine = null;
        var currentRefinementsItems = [];

        const renderCurrentRefinements = window.instantsearch.connectors.connectCurrentRefinements(
            function (renderState, isFirstRender) {
                currentRefinementsRefine = renderState.refine;
                currentRefinementsItems = renderState.items;

                var container = document.querySelector('.aico-filter-refine-by-items');
                if (!container) return;

                var html = renderState.items.flatMap(function (item) {
                    return item.refinements.map(function (r) {
                        var rawVal = String(r.value);
                        var isColor = fieldTypeMap[item.attribute] === 'tag' &&
                            rawVal.indexOf('color_#') === 0;
                        var valueInner;
                        if (isColor) {
                            var hex = rawVal.replace('color_', '');
                            valueInner =
                                '<span class="color-span" title="' + escapeHtml(hex) + '" style="background:' + escapeHtml(hex) +
                                ';height:18px;width:18px;border-radius:100%;border:1px solid;display:inline-block;vertical-align:middle;"></span>';
                        } else {
                            valueInner = escapeHtml(r.label);
                        }
                        return (
                            '<div class="refine-by-item aico-filter-option-label refine-by-type">' +
                            '<span class="refine-by-option" data-filter-key="' + escapeHtml(item.attribute) + '">' +
                            escapeHtml(fieldLabelMap[item.attribute] || item.attribute) + ' : ' +
                            '</span>' +
                            '<span class="refine-by-value" data-filter-value="' + escapeHtml(rawVal) + '">' +
                            valueInner +
                            '</span>' +
                            '<span class="aico-filter-clear"' +
                            ' data-attr="' + escapeHtml(item.attribute) + '"' +
                            ' data-val="' + escapeHtml(rawVal) + '">clear</span>' +
                            '</div>'
                        );
                    });
                }).join('');

                container.innerHTML = html;

                if (isFirstRender) {
                    container.addEventListener('click', function (e) {
                        var clearBtn = e.target.closest('.aico-filter-clear');
                        if (!clearBtn || !currentRefinementsRefine) return;
                        var attr = clearBtn.dataset.attr;
                        var val = clearBtn.dataset.val;
                        _shouldScrollTop = true;
                        currentRefinementsItems.forEach(function (item) {
                            if (item.attribute === attr) {
                                item.refinements.forEach(function (r) {
                                    if (String(r.value) === val) currentRefinementsRefine(r);
                                });
                            }
                        });
                    });
                }
            }
        );
        _search.addWidgets([renderCurrentRefinements({})]);

        var clearAllBtn = document.querySelector('.clear-all-filter');
        if (clearAllBtn) {
            var clearRefine = null;
            const renderClearRefinements = window.instantsearch.connectors.connectClearRefinements(
                function (renderState, isFirstRender) {
                    clearRefine = renderState.refine;
                    clearAllBtn.style.display = renderState.canRefine ? '' : 'none';
                    if (isFirstRender) {
                        clearAllBtn.addEventListener('click', function () {
                            if (clearRefine) { _shouldScrollTop = true; clearRefine(); }
                        });
                    }
                }
            );
            _search.addWidgets([renderClearRefinements({})]);
        }

        var sortByRefine = null;
        const renderSortBy = window.instantsearch.connectors.connectSortBy(
            function (renderState, isFirstRender) {
                sortByRefine = renderState.refine;
                var sortByContainer = document.getElementById('ms-sort-by');
                if (!sortByContainer) return;

                if (isFirstRender) {
                    var select = document.createElement('select');
                    select.name = 'sort_by';
                    select.className = 'af-select';
                    select.id = 'aico-sort-by';
                    select.setAttribute('aria-describedby', 'a11y-refresh-page-message');
                    sortByContainer.appendChild(select);
                    select.addEventListener('change', function () {
                        if (sortByRefine) { _shouldScrollTop = true; sortByRefine(this.value); }
                    });
                }

                var select = document.getElementById('aico-sort-by');
                if (select) {
                    select.innerHTML = renderState.options.map(function (opt) {
                        return (
                            '<option value="' + escapeHtml(opt.value) + '"' +
                            (opt.value === renderState.currentRefinement ? ' selected' : '') +
                            '>' + escapeHtml(opt.label) + '</option>'
                        );
                    }).join('');
                }
            }
        );

        // connectSortBy requires the widget's own indexName to be one of the items,
        // so the collection order is only offered where DEFAULT_SORT uses it
        var sortItems = [];
        if (COLLECTION_SORT) sortItems.push({ label: 'Empfohlen', value: COLLECTION_SORT });
        sortItems.push({ label: 'Neueste zuerst', value: NEWEST_SORT });
        sortItems.push({ label: 'Preis aufsteigend', value: PRICE_ASC_SORT });
        sortItems.push({ label: 'Preis absteigend', value: PRICE_DESC_SORT });

        _search.addWidgets([
            renderSortBy({ items: sortItems })
        ]);

        if (!useInfinite) {
            // Numbered pagination
            const renderHits = window.instantsearch.connectors.connectHits(
                function (renderState, isFirstRender) {
                    var container = document.getElementById('ms-hits');
                    if (!container) return;

                    if (isFirstRender) {
                        if (!_bfcacheRestored && !document.getElementById('ms-hits-list')) {
                            container.innerHTML =
                                '<ul class="af-productGrid" id="ms-hits-list">' +
                                renderSkeletonHtml(hitsPerPage) + '</ul>';
                        }
                        _bfcacheRestored = false;
                        return;
                    }

                    var listEl = document.getElementById('ms-hits-list');
                    if (!listEl) return;

                    if (renderState.hits.length === 0) {
                        listEl.innerHTML =
                            '<li style="list-style:none;grid-column:1/-1;padding:2rem 0;">' +
                            '<p>Keine Produkte gefunden.</p>' +
                            '</li>';
                    } else {
                        listEl.innerHTML = renderState.hits.map(renderHitHtml).join('');
                    }

                    if (_shouldScrollTop) { window.scrollTo({ top: 0, behavior: 'smooth' }); _shouldScrollTop = false; }
                }
            );

            _search.addWidgets([renderHits({})]);

            const renderPagination = window.instantsearch.connectors.connectPagination(
                function (renderState) {
                    var container = document.getElementById('ms-pagination');
                    if (!container) return;

                    _pageRefine = renderState.refine;
                    _pageNbPages = renderState.nbPages;

                    var endEl = document.getElementById('ms-infinite-scroll-end');
                    if (endEl) {
                        var onLastPage = renderState.nbPages > 0 &&
                            renderState.currentRefinement === renderState.nbPages - 1;
                        endEl.style.display = onLastPage ? 'block' : 'none';
                    }

                    if (renderState.nbPages <= 1) {
                        container.innerHTML = '';
                        return;
                    }

                    var current = renderState.currentRefinement;
                    var pages = renderState.pages;

                    var html = '<div class="ms-pagination">';
                    pages.forEach(function (p) {
                        var isCurrent = p === current;
                        var cls = 'ms-page-btn' + (isCurrent ? ' ms-page-btn--active' : '');
                        html +=
                            '<button class="' + cls + '"' +
                            (isCurrent ? ' disabled' : '') +
                            ' data-page="' + p + '">' + (p + 1) + '</button>';
                    });
                    html += '</div>';

                    container.innerHTML = html;

                    if (!_pageListenerAdded) {
                        _pageListenerAdded = true;
                        container.addEventListener('click', function (e) {
                            var b = e.target.closest('.ms-page-btn');
                            if (!b || b.disabled || !_pageRefine) return;
                            var page = parseInt(b.dataset.page, 10);
                            if (page >= 0 && page < _pageNbPages) {
                                _pageRefine(page);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        });
                    }
                }
            );

            _search.addWidgets([renderPagination({ padding: 2 })]);
        } else {
            // Infinite scroll + back-navigation position restore
            setupInfiniteScroll();
        }

        function setupInfiniteScroll() {
            var hitsContainerEl = document.getElementById('ms-hits');
            var loadingEl = document.getElementById('ms-infinite-scroll-loading');
            var endEl = document.getElementById('ms-infinite-scroll-end');
            var sentinelEl = document.getElementById('ms-infinite-scroll-sentinel');
            var paginationEl = document.getElementById('ms-pagination');
            if (paginationEl) paginationEl.style.display = 'none';

            // Mirror the bottom loader above the grid, shown when fetching upward
            var topLoadingEl = null;
            if (loadingEl && hitsContainerEl) {
                topLoadingEl = loadingEl.cloneNode(true);
                topLoadingEl.id = 'ms-infinite-scroll-loading-top';
                topLoadingEl.style.display = 'none';
                hitsContainerEl.insertAdjacentElement('beforebegin', topLoadingEl);
            }

            // Restore decision (and first-page enlargement) was made in startSearch
            var pendingRestore = _restoreSnap;
            var restoring = !!pendingRestore;
            // We reposition manually, so stop the browser restoring scroll itself
            if (restoring) { try { history.scrollRestoration = 'manual'; } catch (e) {} }

            // Windowed state: a contiguous range of pages [minPage, maxPage] in the
            // DOM, appending below and prepending above as the user scrolls
            var paginationRefine = null;
            var nbPages = 1;
            var minPage = -1, maxPage = -1;
            var renderedPages = {};
            var initialized = false;
            var loadingMore = false;
            var pendingPage = -1;
            var canLoadDown = true, canLoadUp = true;
            var restoreTargetPage = -1;
            var restorePages = null;   // [start..end] window of pages to load on restore
            var restoreIdx = 0;        // which restore page we're currently fetching
            var restoreBuffer = {};    // page index -> rendered HTML (buffered until commit)
            var triggersReady = false;
            var lastSig = null;        // signature of the current filter/sort/query set
            var pageZeroKey = null;    // ids of the first page-0 hits, to catch reorder with same signature

            var RESTORE_PAGES_BEFORE = 1;  // pages to load above the product for context
            var RESTORE_PAGES_AFTER = 1;   // pages to load below the product for context

            // Signature of a results set: changes on filter/sort/query, constant across pages
            function searchSig(results) {
                var idx = '';
                // Helper index reflects the selected sort; results.index may stay constant
                try { idx = (_search.helper && _search.helper.state.index) || results.index || ''; } catch (e) {}
                var refs = '';
                try {
                    if (results.getRefinements) {
                        refs = results.getRefinements().map(function (r) { return r.attributeName + '~' + r.name; }).sort().join(',');
                    }
                } catch (e) {}
                return idx + '|' + (results.query || '') + '|' + (results.nbHits != null ? results.nbHits : '') + '|' + refs;
            }

            var loadingShownAt = 0;
            function showLoading(on, where) {
                if (!loadingEl && !topLoadingEl) return;
                var top = (where === 'top') && topLoadingEl;
                if (on) {
                    if (loadingEl) loadingEl.style.display = top ? 'none' : 'block';
                    if (topLoadingEl) topLoadingEl.style.display = top ? 'block' : 'none';
                    loadingShownAt = Date.now();
                    return;
                }
                function hide() {
                    if (loadingEl) loadingEl.style.display = 'none';
                    if (topLoadingEl) topLoadingEl.style.display = 'none';
                }
                var elapsed = Date.now() - loadingShownAt;   // keep visible >=400ms
                if (elapsed >= 400 || !loadingShownAt) hide();
                else setTimeout(hide, 400 - elapsed);
            }

            function updateEndMessage() {
                if (endEl) endEl.style.display = (maxPage >= nbPages - 1) ? 'block' : 'none';
            }

            function cardHtml(hits) { return hits.map(renderHitHtml).join(''); }

            // Fetch a page and append/prepend it relative to the current window
            function loadPage(p, dir) {
                if (!paginationRefine || loadingMore || p < 0 || p > nbPages - 1) return;
                loadingMore = true;
                pendingPage = p;
                showLoading(true, dir === 'prepend' ? 'top' : 'bottom');
                paginationRefine(p);
            }

        // One scroll handler drives both directions (append down, prepend up)
            var scrollAdded = false;
            function ensureTriggers() {
                if (triggersReady || scrollAdded) { triggersReady = true; return; }
                triggersReady = true;
                scrollAdded = true;
                var ticking = false;
                window.addEventListener('scroll', function () {
                    if (ticking) return;
                    ticking = true;
                    window.requestAnimationFrame(function () {
                        ticking = false;
                        if (!initialized || restoring || loadingMore) return;
                        var y = window.scrollY || window.pageYOffset;
                        var scrollBottom = y + window.innerHeight;
                        var docHeight = document.documentElement.scrollHeight;

                        // Reference point is the bottom edge of the product grid, not the
                        // document. SEO copy and the footer sit below the grid and are
                        // several viewports tall on mobile, so a docHeight-based trigger
                        // only fired once the user had scrolled into the footer.
                        // Falls back to docHeight if the container is missing.
                        var gridBottom = hitsContainerEl
                            ? y + hitsContainerEl.getBoundingClientRect().bottom
                            : docHeight;

                        // Lead distance: 1.5 viewports, at least 900px. The next page is
                        // fetched before the last product row becomes visible.
                        var lead = Math.max(900, Math.round(window.innerHeight * 1.5));

                        // Re-arm 300px above the load zone so one scroll gesture can't
                        // fire the trigger twice.
                        if (scrollBottom < gridBottom - lead - 300) canLoadDown = true;
                        if (y > 1000) canLoadUp = true;
                        if (scrollBottom >= gridBottom - lead && canLoadDown && maxPage < nbPages - 1) {
                            canLoadDown = false;
                            loadPage(maxPage + 1, 'append');
                        } else if (y <= 800 && canLoadUp && minPage > 0) {
                            canLoadUp = false;
                            loadPage(minPage - 1, 'prepend');
                        }
                    });
                }, { passive: true });
            }

            // After the window is set, scroll so the clicked card sits at its old offset
            function repositionToProduct() {
                var path = pendingRestore.productPath;
                var anchorOffset = pendingRestore.anchorOffset || 0;
                function findCard() {
                    if (!path) return null;
                    var a = document.querySelector('#ms-hits-list a[href="' + path + '"]') ||
                            document.querySelector('#ms-hits-list a[href*="' + path + '"]');
                    return a ? (a.closest('.af-productGrid_item') || a) : null;
                }
                function apply() {
                    var card = findCard();
                    if (!card) return;
                    var delta = card.getBoundingClientRect().top - anchorOffset;
                    if (Math.abs(delta) > 1) window.scrollBy(0, delta);
                }

                // Position now, then hold against external scroll-restoration (native/app) for
                // a few seconds; corrections run before paint, a real user scroll releases it
                var htmlEl = document.documentElement;
                var prevBehavior = htmlEl.style.scrollBehavior;
                htmlEl.style.scrollBehavior = 'auto';   // make our corrections instant
                apply();
                var holdStart = Date.now(), released = false;
                var userEvents = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
                function release() {
                    if (released) return;
                    released = true;
                    htmlEl.style.scrollBehavior = prevBehavior;
                    userEvents.forEach(function (ev) { window.removeEventListener(ev, release); });
                }
                function holdFrame() {
                    if (released) return;
                    apply();
                    if (Date.now() - holdStart > 4000) { release(); return; }
                    requestAnimationFrame(holdFrame);
                }
                userEvents.forEach(function (ev) { window.addEventListener(ev, release, { passive: true }); });
                requestAnimationFrame(holdFrame);
            }

            // Pagination connector, only to drive page changes + read nbPages
            var renderPagination = window.instantsearch.connectors.connectPagination(
                function (renderState) {
                    paginationRefine = renderState.refine;
                    if (renderState.nbPages) nbPages = renderState.nbPages;
                    if (paginationEl) paginationEl.innerHTML = '';
                }
            );

            // Hits connector renders the current page only, we accumulate into the DOM
            var renderHits = window.instantsearch.connectors.connectHits(
                function (renderState, isFirstRender) {
                    if (isFirstRender) {
                        if (!_bfcacheRestored && !document.getElementById('ms-hits-list')) {
                            hitsContainerEl.innerHTML =
                                '<ul class="af-productGrid" id="ms-hits-list">' +
                                renderSkeletonHtml(Math.min(hitsPerPage, 36)) + '</ul>';
                        }
                        _bfcacheRestored = false;
                        return;
                    }

                    var listEl = document.getElementById('ms-hits-list');
                    if (!listEl) {
                        hitsContainerEl.innerHTML = '<ul class="af-productGrid" id="ms-hits-list"></ul>';
                        listEl = document.getElementById('ms-hits-list');
                    }

                    var results = renderState.results || {};
                    if (results.nbPages) nbPages = results.nbPages;
                    var page = typeof results.page === 'number' ? results.page : 0;
                    var hits = renderState.hits || [];

                    if (hits.length === 0 && page === 0) {
                        listEl.innerHTML =
                            '<li style="list-style:none;grid-column:1/-1;padding:2rem 0;">' +
                            '<p>Keine Produkte gefunden.</p></li>';
                        renderedPages = {}; minPage = maxPage = -1; initialized = false;
                        loadingMore = false; pendingPage = -1; _currentLoadedCount = 0; _gridMinPage = 0;
                        if (endEl) endEl.style.display = 'none';
                        showLoading(false);
                        return;
                    }

                    // Restore: fetch a small window of pages around the product, buffer
                    // them (skeleton stays up), then render + position in one shot
                    if (restoring) {
                        if (restorePages === null) {
                            restoreTargetPage = Math.floor((pendingRestore.index || 0) / hitsPerPage);
                            if (restoreTargetPage > nbPages - 1) restoreTargetPage = nbPages - 1;
                            if (restoreTargetPage < 0) restoreTargetPage = 0;
                            var start = Math.max(0, restoreTargetPage - RESTORE_PAGES_BEFORE);
                            var end = Math.min(nbPages - 1, restoreTargetPage + RESTORE_PAGES_AFTER);
                            restorePages = [];
                            for (var rp = start; rp <= end; rp++) restorePages.push(rp);
                            restoreIdx = 0;
                        }
                        var expected = restorePages[restoreIdx];
                        if (page !== expected) {
                            if (pendingPage !== expected) {
                                pendingPage = expected;
                                setTimeout(function () { if (paginationRefine) paginationRefine(expected); }, 0);
                            }
                            return;
                        }
                        restoreBuffer[page] = cardHtml(hits);   // buffer, don't show yet
                        restoreIdx++;
                        if (restoreIdx < restorePages.length) {
                            var np = restorePages[restoreIdx];
                            pendingPage = np;
                            setTimeout(function () { if (paginationRefine) paginationRefine(np); }, 0);
                            return;
                        }
                        // All window pages fetched, commit at once
                        var html = '';
                        renderedPages = {};
                        for (var i = 0; i < restorePages.length; i++) {
                            html += restoreBuffer[restorePages[i]];
                            renderedPages[restorePages[i]] = true;
                        }
                        listEl.innerHTML = html;
                        minPage = restorePages[0];
                        maxPage = restorePages[restorePages.length - 1];
                        initialized = true; restoring = false; loadingMore = false; pendingPage = -1;
                        canLoadUp = canLoadDown = true;
                        lastSig = searchSig(results);
                        _gridMinPage = minPage;
                        _currentLoadedCount = listEl.querySelectorAll('.af-productGrid_item').length;
                        restoreBuffer = {};
                        updateEndMessage();
                        showLoading(false);
                        repositionToProduct();
                        clearRestoreSnapshot();
                        ensureTriggers();
                        return;
                    }

                    // Rebuild on filter/sort/query change, first load, or when the page-0 hits
                    // change (a sort can reorder the same set, leaving the signature unchanged)
                    var sig = searchSig(results);
                    var firstKey = hits.slice(0, 8).map(function (h) { return h.id; }).join(',');
                    if (page === 0 && (!initialized || sig !== lastSig || firstKey !== pageZeroKey)) {
                        lastSig = sig;
                        pageZeroKey = firstKey;
                        listEl.innerHTML = cardHtml(hits);
                        renderedPages = { 0: true };
                        minPage = maxPage = 0;
                        initialized = true; loadingMore = false; pendingPage = -1;
                        canLoadUp = canLoadDown = true;
                        _gridMinPage = 0;
                        _currentLoadedCount = listEl.querySelectorAll('.af-productGrid_item').length;
                        if (_shouldScrollTop) { window.scrollTo({ top: 0, behavior: 'smooth' }); _shouldScrollTop = false; }
                        updateEndMessage();
                        showLoading(false);
                        ensureTriggers();
                        return;
                    }

                    // Drop stale renders: a page fetched under a previous sort/filter that
                    // arrives after the grid changed would otherwise be appended out of order
                    if (sig !== lastSig) {
                        loadingMore = false; showLoading(false);
                        return;
                    }

                    // Windowed append / prepend of an adjacent page
                    if (renderedPages[page]) { loadingMore = false; showLoading(false); return; }

                    if (page === maxPage + 1) {
                        listEl.insertAdjacentHTML('beforeend', cardHtml(hits));
                        maxPage = page;
                    } else if (page === minPage - 1) {
                        // Hide the top loader first so it isn't counted in the height delta
                        if (topLoadingEl) topLoadingEl.style.display = 'none';
                        var prevH = document.documentElement.scrollHeight;
                        var prevY = window.scrollY || window.pageYOffset;
                        listEl.insertAdjacentHTML('afterbegin', cardHtml(hits));
                        var newH = document.documentElement.scrollHeight;
                        window.scrollTo(0, prevY + (newH - prevH));   // keep viewport stable
                        minPage = page;
                    } else {
                        loadingMore = false; showLoading(false); return;   // non-adjacent, ignore
                    }

                    renderedPages[page] = true;
                    loadingMore = false; pendingPage = -1;
                    _gridMinPage = minPage;
                    _currentLoadedCount = listEl.querySelectorAll('.af-productGrid_item').length;
                    updateEndMessage();
                    showLoading(false);
                    ensureTriggers();
                }
            );

            _search.addWidgets([renderPagination({}), renderHits({})]);
        }

        if (searchMode) {
            var virtualSearchBox = window.instantsearch.connectors.connectSearchBox(
                function () { }
            );
            _search.addWidgets([virtualSearchBox({})]);
        }

        _search.start();

        initMobileFilter();
    }

    function initMobileFilter() {
        var filterToggle = document.querySelector('.af-filterOption');
        var filterSidebar = document.querySelector('.aico-filters');
        var closeIcon = document.querySelector('.aico-close-icon');
        var body = document.body;

        if (!filterToggle || !filterSidebar) return;

        filterToggle.addEventListener('click', function (e) {
            e.preventDefault();
            filterSidebar.classList.add('af-mobile-view-filter-option');
            body.classList.add('aico-gradient');
        });

        if (closeIcon) {
            closeIcon.addEventListener('click', function (e) {
                e.preventDefault();
                filterSidebar.classList.remove('af-mobile-view-filter-option');
                body.classList.remove('aico-gradient');
            });
        }

        document.addEventListener('click', function (e) {
            if (body.classList.contains('aico-gradient') &&
                !filterSidebar.contains(e.target) &&
                !filterToggle.contains(e.target)) {
                filterSidebar.classList.remove('af-mobile-view-filter-option');
                body.classList.remove('aico-gradient');
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initInstantSearch);
    } else {
        initInstantSearch();
    }

})();
